import Component from '../colorz/Component';

export default class WishlistHeartFocus extends Component {
	static pendingObservers = new WeakMap();

	static selectors = {
		addBtn: '.js-product-heart-add',
		removeBtn: '.js-product-heart-remove',
		heartButtons: '.js-product-heart-add, .js-product-heart-remove',
	};

	onInit(el) {
		this.onHeartClick = this.onHeartClick.bind(this);
		this.el = el;
		this.hasAttachedListener = false;
	}

	onReady() {
		if (this.el.dataset.wishlistHeartFocusInit) {
			return;
		}

		this.hasAttachedListener = true;
		this.el.dataset.wishlistHeartFocusInit = '1';
		this.bindEvents();
	}

	bindEvents() {
		this.el.addEventListener('click', this.onHeartClick, true);
	}

	onDestroy() {
		if (this.hasAttachedListener) {
			this.el.removeEventListener('click', this.onHeartClick, true);
			delete this.el.dataset.wishlistHeartFocusInit;
		}
		super.onDestroy();
	}

	onHeartClick(e) {
		if (e.detail !== 0) {
			return;
		}

		const button = e.target.closest(WishlistHeartFocus.selectors.heartButtons);
		if (!button || !this.el.contains(button)) {
			return;
		}

		this.scheduleFocusRestore();
	}

	scheduleFocusRestore() {
		this.disconnectPendingObserver();

		const observer = new MutationObserver(() => {
			const target = this.getVisibleHeartButton();
			if (!target || this.isHeartHidden(target)) {
				return;
			}
			target.focus({preventScroll: true});
			this.disconnectPendingObserver();
		});

		observer.observe(this.el, {
			subtree: true,
			attributes: true,
			attributeFilter: ['class', 'hidden'],
		});
		WishlistHeartFocus.pendingObservers.set(this.el, observer);

		window.setTimeout(() => this.disconnectPendingObserver(), 5000);
	}

	disconnectPendingObserver() {
		const obs = WishlistHeartFocus.pendingObservers.get(this.el);
		if (obs) {
			obs.disconnect();
			WishlistHeartFocus.pendingObservers.delete(this.el);
		}
	}

	getVisibleHeartButton() {
		const addBtn = this.el.querySelector(WishlistHeartFocus.selectors.addBtn);
		const removeBtn = this.el.querySelector(
			WishlistHeartFocus.selectors.removeBtn,
		);
		if (!addBtn || !removeBtn) {
			return null;
		}
		return this.isHeartHidden(addBtn) ? removeBtn : addBtn;
	}

	isHeartHidden(el) {
		return el.classList.contains('u-hidden') || el.hasAttribute('hidden');
	}
}
